import styled from 'styled-components';
import { IonTextarea } from '@ionic/react';
import { TextField, Button as MuiButton } from '@mui/material';

import colors from '../../../../styles/colors';

// Fields stack with consistent spacing inside the shared modal body. White input
// fills read as cards against the modal's light-blue surface (matches the Broadcast
// modal, whose inputs are likewise white-filled).
const FormFields = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  .MuiInputBase-root {
    background-color: ${colors.base.alpha};
  }
`;

const FieldRow = styled.div`
  display: flex;
  gap: 12px;
`;

// The task's subject when it's tied to a client. Removing the chip un-ties the task
// (subject falls back to the coach), so its task types switch to the client-less set.
// Wraps the chip so it keeps its natural width and stays flush-left with the form fields.
const SubjectRow = styled.div`
  display: flex;
  align-items: center;
`;

const StyledTextField = styled(TextField)`
  width: 100%;
`;

const StyledTextarea = styled(IonTextarea)`
  --padding-start: 14px;
  --background: ${colors.base.alpha};
  border: 1px solid;
  border-radius: 5px;
`;

const AttachButton = styled(MuiButton)`
  align-self: flex-start;
  text-transform: none;
`;

// AttachmentsPreview is tuned for the chat input (a short, internally-scrolling strip).
// In the modal we let the previews flow (the modal body scrolls) and size the
// thumbnails up so they aren't cramped.
const AttachmentsPreviewWrapper = styled.div`
  & > div {
    max-height: none;
    overflow-y: visible;
    padding-right: 0;
  }

  /* Don't stretch the "add" tile to the row's height. */
  .rfu-image-previewer {
    align-items: flex-start;
  }

  /* Keep every tile (image thumbnails + the "add" button) a uniform 120px square. */
  .rfu-image-previewer__image,
  .rfu-image-previewer__image .rfu-thumbnail__wrapper,
  .rfu-image-upload-button,
  .rfu-thumbnail-placeholder {
    width: 120px !important;
    height: 120px !important;
    min-width: 0;
    min-height: 0;
  }
`;

export {
  FormFields,
  FieldRow,
  SubjectRow,
  StyledTextField,
  StyledTextarea,
  AttachButton,
  AttachmentsPreviewWrapper,
};
